__turbopack_context__.v({
  "search-container": "Search-module__nVQUaW__search-container",
  "search-title": "Search-module__nVQUaW__search-title",
  "search__loader": "Search-module__nVQUaW__search__loader",
});
